import css from "styled-jsx/css";

export default css`
  .general-managment-fake {
    width: 100%;
    margin-left: 0;
    &--title {
      height: 22px;
      width: 20%;
    }
    &--container {
      margin-bottom: 2rem;
      &--box-container {
        margin-top: 1rem;
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
      }
      &--box {
        height: 60px;
        width: 100%;
        background-color: #f5f5f5;
        padding: 0.2rem 1rem;
      }
    }
    &--footer {
      height: 200px;
      width: 100%;
    }
  }

  @media (min-width: 768px) {
    .general-managment-fake {
      width: 60%;
      &--container {
        &--box {
          flex: 1 0 calc(50% - 1rem);
        }
      }
    }
  }
`;
